import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  SELECTED_ITEMS_TEXT: `${cleanedFilename(__filename)}-selected-items-text`,
};
